import {useEffect} from 'react'

import useEventCallback from 'lib/vendor/use-event-callback'

/**
 * Wrapper around `useEventCallback` and adding / removing a listener to `window` in a `useEffect`.
 * Allows us to listen to window events in a single line. Ex:
 * ```ts
 * useWindowEventListener('keydown', (ev) => console.log(ev.key))
 * ```
 */
export default function useWindowEventListener<K extends keyof WindowEventMap>(
  event: K,
  listener: (this: Window, ev: WindowEventMap[K]) => any
): void {
  // Event callback is stable.
  const eventCallback = useEventCallback(listener)
  useEffect(() => {
    window.addEventListener(event, eventCallback)
    return () => window.removeEventListener(event, eventCallback)
  }, [event, eventCallback]) // Run once on mount / unmount
}
